import { useContext } from "react";
import { MdArrowForward, MdLocalPhone, MdMailOutline } from "react-icons/md";
import { AppContext } from "../App";

export default function CallToAction() {
  const appContext = useContext(AppContext);

  return (
    <section className="MainBodySection call-to-action-section">
      <div className="container">
        <div className="call-to-action-bar" data-aos="fade-up">
          <div className="call-to-action-copy">
            <p className="home-banner-kicker">Ready to Print?</p>
            <h2 className="font-bold">Let us turn your idea into something people can hold.</h2>
          </div>

          <div className="call-to-action-actions">
            <button
              type="button"
              className="call-to-action-btn"
              onClick={() => appContext.navTo({ item: "contact_us" })}
            >
              Request a Quote
              <MdArrowForward size={20} />
            </button>

            <a className="call-to-action-contact" href="tel:+255717515036">
              <MdLocalPhone size={18} />
              <span>+255 717 515 036</span>
            </a>

            <a className="call-to-action-contact" href="mailto:info@esmeriser.co.tz">
              <MdMailOutline size={18} />
              <span>info@esmeriser.co.tz</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
